module.exports = __webpack_public_path__ + "img/adhka-yx1zn.017.38513540.jpeg";